import { render, staticRenderFns } from "./LiveChatMp4V2Dialog.vue?vue&type=template&id=017c83a4&scoped=true&"
import script from "./LiveChatMp4V2Dialog.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4V2Dialog.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4V2Dialog.vue?vue&type=style&index=0&id=017c83a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c83a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSelect,VTextField})
